<template>
  <transition :name="transition ? 'height' : null" @enter="startTransition" @before-leave="startTransition">
    <slot />
  </transition>
</template>

<script>
export default {
  props: {
    transition: { type: Boolean, default: true }
  },
  methods: {
    startTransition (el) {
      el.style.height = el.scrollHeight + 'px'
    },
  }
}
</script>

<style scoped>
.height-enter-active,
.height-leave-active {
  will-change: height;
  transition: height 0.4s ease;
}

.height-enter,
.height-leave-to {
  height: 0 !important;
}

</style>
